/**
 * What is deployed, migrated, backed up and built — `/v1/admin/ops/status` (CSR-158, R6).
 *
 * **Any scope reads it**, as job health. Every "never" arrives as an explicit `null` and the
 * screen says "never", because a blank or a zero would read as a pass.
 */
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { authedClient } from '../../auth/session';
import { keys } from '../queryClient';
import type { components } from '../../../api/generated/schema';

export type OpsStatus = components['schemas']['OpsStatusResponse'];
export type DrillRow = components['schemas']['DrillRow'];
type DrillList = components['schemas']['DrillListResponse'];

export function useOpsStatus() {
  return useQuery({
    queryKey: keys.ops.status(),
    queryFn: () => authedClient.request<OpsStatus>('/v1/admin/ops/status'),
  });
}

/**
 * The restore-drill register (R309, devops 09 §5): every drill as the job recorded it, newest
 * first. A row is written once when the drill finishes, so the id is a stable keyset cursor.
 */
export function useOpsDrills() {
  return useInfiniteQuery({
    queryKey: keys.ops.drills(),
    initialPageParam: undefined as number | undefined,
    queryFn: ({ pageParam }) =>
      authedClient.request<DrillList>(
        `/v1/admin/ops/drills?limit=50${pageParam === undefined ? '' : `&cursor=${pageParam}`}`,
      ),
    getNextPageParam: (last) => last.next_cursor ?? undefined,
  });
}
